import React from 'react';
import { Button } from '@mui/material';
import { OpenInNew } from '@mui/icons-material';
import { tokens } from '../theme/tokens';
import { useAppTranslation } from '../i18n/useAppTranslation';
import { externalLinksFor, IntegrationLinkSource } from '../utils/integrationExternalLinks';

/** "Open store" and "<Platform> admin" buttons for the integration header; renders nothing when neither link is known. */
const IntegrationExternalLinks: React.FC<{ integration: IntegrationLinkSource; compact?: boolean }> = ({ integration, compact = false }) => {
  const { t } = useAppTranslation();
  const { storefront, admin, adminLabel } = externalLinksFor(integration);
  if (!storefront && !admin) return null;

  const linkProps = {
    variant: compact ? 'text' : 'outlined',
    size: 'small',
    target: '_blank',
    rel: 'noopener noreferrer',
    endIcon: <OpenInNew sx={{ fontSize: 16 }} />,
    sx: compact ? { color: tokens.ink.bodyAlt, fontWeight: 600, fontSize: 13 } : { height: 36 },
  } as const;
  const openStore = t('integrations.externalLinks.openStore');
  return (
    <>
      {storefront && (
        <Button {...linkProps} href={storefront} aria-label={t('integrations.externalLinks.openStoreAria', { url: storefront })}>
          {openStore}
        </Button>
      )}
      {admin && (
        <Button {...linkProps} href={admin} aria-label={t('integrations.externalLinks.openAdminAria', { label: adminLabel })}>
          {adminLabel}
        </Button>
      )}
    </>
  );
};

export default IntegrationExternalLinks;
